"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextareaContainer = exports.StyledTextareaComponent = exports.StyledMultiline = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledTextareaComponent = _styledComponents.default.div.withConfig({
  displayName: "Textareastyles__StyledTextareaComponent",
  componentId: "sc-xfqerd-0"
})(["font-family:", ";", ";.error{margin-top:4px;margin-left:1px;letter-spacing:0.02em;font-size:13px;color:", ";}"], _shared.theme.typography.link.fontFamily, ({
  width
}) => width && `width: ${width}`, _shared.theme.palette.ui.cta.red);

exports.StyledTextareaComponent = StyledTextareaComponent;

const StyledTextareaContainer = _styledComponents.default.div.withConfig({
  displayName: "Textareastyles__StyledTextareaContainer",
  componentId: "sc-xfqerd-1"
})([".textarea_parent{width:100%;height:100%;position:relative;box-sizing:border-box;display:block;}&.disabled{textarea{pointer-events:none;opacity:0.5;color:inherit;}.textarea__label{color:", ";}}.textarea{&__label{font-size:13px;font-weight:normal;display:block;z-index:1;text-overflow:ellipsis;box-sizing:border-box;color:", ";padding-bottom:16px;letter-spacing:0.02em;padding-top:26px;&--hidden{position:absolute;text-indent:-9999px;}}}&.container_focus{.parent{border-top:none;border:1px solid ", ";padding:16px;}.has-edit{padding-bottom:25px;}.limit{display:block;}.textarea{&__label{color:", ";}}}&.filled{.textarea{&__label{color:", ";}}}&.filled:not(.container_focus){.textarea{&__label{padding-bottom:9px;}}}.has-content{padding:0px 0px 16px 0px;border:none;border-bottom:1px solid ", ";}"], _shared.theme.palette.ui.neutral.grey7, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.neutral.grey4, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.charcoal);

exports.StyledTextareaContainer = StyledTextareaContainer;

const StyledMultiline = _styledComponents.default.div.withConfig({
  displayName: "Textareastyles__StyledMultiline",
  componentId: "sc-xfqerd-2"
})(["position:relative;border-top:1px solid ", ";textarea{max-width:100%;box-sizing:border-box;width:100%;resize:none;border:none;outline:none;font-size:16px;padding:0px;color:", ";font-family:", ";display:block;", "}.limit{display:flex;position:absolute;bottom:3px;right:6px;display:none;color:", ";font-size:12px;}.edit-text-button{", ";color:", ";cursor:pointer;width:min-content;position:absolute;bottom:3px;left:15px;}"], _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.charcoal, _shared.theme.typography.link.fontFamily, ({
  isFocused,
  hasContent
}) => !isFocused && !hasContent && `
    height: 0px !important;
    `, _shared.theme.palette.ui.neutral.grey2, _shared.theme.typography.link.css, _shared.theme.palette.ui.cta.blue);

exports.StyledMultiline = StyledMultiline;